import React from 'react';
import './AssistIcon.css';

interface AssistIconProps {
  size?: number;
  team?: 'black' | 'white';
}

const AssistIcon: React.FC<AssistIconProps> = ({ size = 20, team = 'black' }) => {
  const iconPath = team === 'black' 
    ? '/icons/asist-icon-black.png.png'
    : '/icons/asist-icon-white.png.png';

  return (
    <img 
      src={iconPath} 
      alt="Asist" 
      className="assist-icon"
      style={{ width: size, height: size }}
      onError={(e) => {
        // Takıma özel ikon yüklenemezse varsayılan ikonu göster
        e.currentTarget.src = '/icons/asist-icon.png.png';
      }}
    />
  );
};

export default AssistIcon;

